import React from 'react';
import Tasks from './components/Tasks';
import './App.css';

function App() {
  return (
    <div className="App">
      <Tasks />
    </div>
  );
}

export default App;
